export default "__VITE_ASSET__DtGTDUyQ__"